import { readTenantCode } from "./storage"

const isProduction = ()=> process.env.REACT_APP_ENV === 'production'

// 艾迪租户需求
export const isTenant042 = ()=> {
  // 是否显示受试者访视完成数
  if (isProduction()) {
    return readTenantCode() === 'TENANT-042'
  }
  return readTenantCode() ===  'TENANT-0176'
}

// 齐鲁血液演示项目
export const isTenant071 = ()=> {
  return readTenantCode() === 'TENANT-071'
}

// 齐鲁胃肠肿瘤
export const isTenant067 = ()=> readTenantCode() === (isProduction() ? 'TENANT-067' : 'TENANT-0201')

// 君实租户
export const isTenantJS = ()=> {
  return ['TENANT-0668', 'TENANT-056'].includes(readTenantCode())
}